/**
 * `msp` sent to LightReach getQuoteV2 / getPricingV3.
 * Oregon: only the optional pricing bump checkbox (not the Electrical Service adder).
 * Other states: Electrical Service adder (`msp` > 0).
 *
 * @param {string} state Customer / project state name
 * @param {number|string} mspAdderState Electrical service adder (0 = off)
 * @param {boolean} oregonLightreachPricingBump "Increase Lightreach Pricing by $0.01" (Oregon only)
 */
export function getMspForLightReachGetQuote(state, mspAdderState, oregonLightreachPricingBump) {
  if (state === "Oregon") {
    return !!oregonLightreachPricingBump;
  }
  return +mspAdderState > 0;
}
